import React from 'react'
import { object } from 'prop-types'

import Layout from 'layouts/Layout'
import Buy from 'components/buy'

const BuyTemplate = ({ pageContext }) => {
  return (
    <Layout fullHeight lightFooter hideHeader>
      <Buy pageContext={pageContext} />
    </Layout>
  )
}

BuyTemplate.propTypes = {
  pageContext: object.isRequired
}

export default BuyTemplate
